import { ErrorType, PaymentMethodType } from 'data/types'

import * as AT from './actionTypes'

export type FetchPaymentMethodsActionType = {
  payload: { currency: string }
  type: typeof AT.FETCH_PAYMENT_METHODS_TYPE
}
type SetPaymentMethodsActionType = {
  payload: { currency: string; methods: Array<PaymentMethodType> }
  type: typeof AT.SET_PAYMENT_METHODS_TYPE
}
type SetPaymentMethodsLoadingActionType = {
  payload: { currency: string; loading: boolean }
  type: typeof AT.SET_PAYMENT_METHODS_LOADING_TYPE
}
type SetPaymentMethodsErrorActionType = {
  payload: { currency: string; error: ErrorType }
  type: typeof AT.SET_PAYMENT_METHODS_ERROR_TYPE
}

export type PaymentMethodsActionType =
  | FetchPaymentMethodsActionType
  | SetPaymentMethodsActionType
  | SetPaymentMethodsLoadingActionType
  | SetPaymentMethodsErrorActionType

const fetchPaymentMethods = (currency: string): FetchPaymentMethodsActionType => ({
  payload: { currency },
  type: AT.FETCH_PAYMENT_METHODS_TYPE
})
export const setPaymentMethods = (
  currency: string,
  methods: Array<PaymentMethodType>
): SetPaymentMethodsActionType => ({
  payload: { currency, methods },
  type: AT.SET_PAYMENT_METHODS_TYPE
})
export const setPaymentMethodsLoading = (
  currency: string,
  loading: boolean
): SetPaymentMethodsLoadingActionType => ({
  payload: { currency, loading },
  type: AT.SET_PAYMENT_METHODS_LOADING_TYPE
})
export const setPaymentMethodsError = (
  currency: string,
  error: ErrorType
): SetPaymentMethodsErrorActionType => ({
  payload: { currency, error },
  type: AT.SET_PAYMENT_METHODS_ERROR_TYPE
})

export default {
  fetchPaymentMethods,
  setPaymentMethods,
  setPaymentMethodsError,
  setPaymentMethodsLoading
}
